import { toFormUrlEncoded } from "../utils/utils";
import { CHAT_URL, HOME, MSRA } from "../../config";

const PRODUCTION_MSRA = "https://member-streaming.live/vm-ept/wa";
const VIEWER_PING_URL = "https://msstate.member-streaming.live/ping.png";
const VIEWER_COUNT_WS_CODE = "16be916a-347z-7f90-n32x-2rtu381w06m7";

const axios = require("axios");
import { md5 } from "pure-md5";

// Random per-browser viewer id. A device fingerprint gave identical devices
// (same phone model, managed laptops) the same id, so they counted as one viewer.
function newViewerToken() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
        return window.crypto.randomUUID();
    }
    return Date.now().toString(36) + "-" + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
}

function normalizeMsraBase(url) {
    const base = url || PRODUCTION_MSRA;
    return base.endsWith("/") ? base : `${base}/`;
}

export class RestMS {
    constructor(app, stream, encId, jsonEng) {
        this.serverUrl = normalizeMsraBase(MSRA);
        this.apiPrefix = "ss2/hash";
        this.stateApi = this.serverUrl + this.apiPrefix + encId;
        this.app = app;
        this.stream = stream;
        this.appMD5 = md5(app);
        this.streamMD5 = md5(stream);
        this.encId = encId;
        this.jsonEng = jsonEng;
        this.typeStream = "free";

        console.log("--------->>> app ", this.app);
        console.log("--------->>> appMD5", this.appMD5);
    }

    setTypeStream(typeStream) {
        this.typeStream = typeStream;
    }

    //  getNearest5MinUTC() {
    //     const now = new Date();
    //
    //     const minutes = now.getUTCMinutes();
    //     const roundedMinutes = Math.floor(minutes / 5) * 5; // Round down to nearest 5 minutes
    //
    //     now.setUTCMinutes(roundedMinutes);
    //     now.setUTCSeconds(0);
    //     now.setUTCMilliseconds(0);
    //
    //      const year = now.getUTCFullYear();
    //      const month = String(now.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based in JS
    //      const day = String(now.getUTCDate()).padStart(2, '0');
    //      const hour = String(now.getUTCHours()).padStart(2, '0');
    //      const minute = String(now.getUTCMinutes()).padStart(2, '0');
    //
    //      console.log( `${year}${month}${day}${hour}${minute}` )
    //
    //      return `${year}${month}${day}${hour}${minute}`;
    // }

    getTimestamp() {
        let fetchTime = 4; // time in seconds
        let now = Math.floor(Date.now() / 1000);
        // Bucket the timestamp into `fetchTime`-second windows so the cache-buster
        // value changes (at most) once every `fetchTime` seconds.
        let queryStringTime = "" + Math.floor(now / fetchTime);

        return queryStringTime;
    }

    getJsonURL(server_code) {
        //return this.serverUrl + "ws/" + server_code + "?_=" + queryStringTime;

        const timeStamp = this.getTimestamp();
        return this.serverUrl + "ws/" + server_code + "?_=" + timeStamp;

        // remove caching
        //return this.serverUrl + "ws/" + server_code;
    }

    callFetch(
        restApi,
        successFnc,
        errorFnc,
        data = {},
        method = "GET",
        bearerToken = "",
    ) {

        let fetchConf = {
            method: method, // *GET, POST, PUT, DELETE, etc.
            headers: {
                "Access-Control-Allow-Origin": "*",
                Accept: "application/json",
            },
        };

        // remove caching
        //restApi = restApi + "?_=" + queryStringTime;

        const timeStamp = this.getTimestamp();
        //restApi = restApi + "?_=" + timeStamp;
        restApi = restApi + "?_=" + timeStamp;

        if (["PUT", "POST", "DELETE", "PATCH"].includes(method.toUpperCase())) {
            fetchConf["headers"]["Content-Type"] =
                "application/x-www-form-urlencoded;charset=UTF-8";
            fetchConf["body"] = toFormUrlEncoded(data);
        } else if (Object.keys(data).length > 0) {
            let queryString = new URLSearchParams(data).toString();
            if (queryString && queryString != "") {
                restApi = restApi + "&" + queryString;
            }
            console.log("=======> data", data);
            console.log("=======> queryString", queryString);
        }

        // Embedded wa/* endpoints validate JWT from POST auth; Bearer triggers global iss checks.
        if (bearerToken != "" && !(data && data.auth)) {
            fetchConf["headers"]["Authorization"] = "Bearer " + bearerToken;
        }

        fetch(restApi, fetchConf)
            .then((response) => response.json())
            .then((resp) => {
                successFnc(resp);
            })
            .catch((error) => {
                errorFnc(error);
            });
    }

    restRequest(restApi, data, successFnc, errorCb, bearerToken = "") {
        if (data) {
            data["sid"] = this.encId;
        } else {
            data = { sid: this.encId };
        }

        this.callFetch(
            this.serverUrl + restApi,
            (resp) => {
                successFnc(resp);
            },
            (error) => {
                errorCb(error);
            },
            data,
            "POST",
            bearerToken,
        );
    }

    getRestRequest(restApi, data, bearerToken = "") {
        if (data) {
            data["sid"] = this.encId;
            data["_"] = Date.now();
        } else {
            data = { sid: this.encId, _: Date.now() };
        }
        return axios.get(this.serverUrl + restApi, {
            crossDomain: true,
            params: data,
        });
    }

    pingStream(successFnc, errorCb) {
        this.callFetch(
            this.stateApi,
            (resp) => {
                console.log("active check");
                successFnc(
                    resp.actives?.some((it) => it.includes(this.streamMD5)),
                );
            },
            (error) => {
                errorCb(error);
            },
        );
    }

    getStreamData(successFnc, errorCb) {
        this.callFetch(
            this.serverUrl + "sd/" + this.encId + "?type=" + this.typeStream,
            (resp) => {
                if (!resp.success) {
                    errorCb(resp);
                    return;
                }
                try {
                    let jsonResp = JSON.parse(atob(resp.data));
                    let dataSplited = atob(jsonResp.o).split(":::");
                    console.log(JSON.stringify(jsonResp));
                    successFnc({
                        data: JSON.parse(dataSplited[0]),
                        key: dataSplited[1],
                    });
                } catch (e) {
                    console.error(e);
                    errorCb(resp);
                }
            },
            (error) => {
                errorCb(error);
            },
        );
    }

    getRandomNumber() {
        return Math.floor(Math.random() * 101); // Generates a number between 0 and 100 (inclusive)
    }

    /**
     * Send the viewer ping (only while the viewer is watching) and refresh the
     * viewer count shown in the player.
     */
    async sendAndGetTrackingData(sendPing = true) {
        const stream_payload = document.getElementById("stream_payload");
        if (!stream_payload) {
            return;
        }

        const stream_data = JSON.parse(stream_payload.attributes["data-stream-data"].value);
        const stream_id = parseInt(stream_data.vm_stream_id);
        if (!stream_id) {
            return;
        }

        const application_name = stream_data.application;
        const stream_name = stream_data.stream;

        if (sendPing) {
            try {
                const code = await this.identifyUser(stream_id, application_name, stream_name, stream_data);
                const queryString = new URLSearchParams(code).toString();
                await axios.get(queryString.length > 0 ? VIEWER_PING_URL + "?" + queryString : VIEWER_PING_URL, {
                    crossDomain: true,
                });
            } catch (e) {
                // a failed ping must not stop the viewer count refresh
                console.error("viewer ping failed", e);
            }
        }

        // # --------- get tracking data
        let jsonData;
        try {
            const viewer_count_req = this.serverUrl + "ws/" + VIEWER_COUNT_WS_CODE + "?_=" + this.getTimestamp();
            jsonData = (await axios.get(viewer_count_req, { crossDomain: true })).data;
        } catch (e) {
            console.error("viewer count fetch failed", e);
            return;
        }
        // no snapshot at all (expired or never written) means no viewers
        if (jsonData === null || jsonData === "") {
            jsonData = {};
        }
        if (typeof jsonData !== "object") {
            return;
        }

        let fromVal = 0;
        try {
            fromVal = parseInt(localStorage.getItem(`stream_data_${stream_id}`)) || 0;
        } catch (e) { }

        // a stream missing from the snapshot has no viewers: show 0, not the last count
        const count = parseInt(jsonData[md5(application_name)]?.[md5(stream_name)]);
        const _value = Number.isNaN(count) ? 0 : count;

        window.dispatchEvent(new CustomEvent("viewer-count", {
            detail: {
                from: fromVal,
                to: _value,
                stream_id: stream_id,
            }
        }));

        try {
            localStorage.setItem(`stream_data_${stream_id}`, _value);
        } catch (e) { }
    }

    async checkStreamEngine() {
        // will check engine, send to the correct cdn and will input access_code or username if exists
        //console.log("checkStreamEngine");

        return new Promise(async (resolve, reject) => {
            let msraStreamStateError = 0;
            let stream_data;
            let stream_data_string;

            let stream_id_hashed;
            let stream_name_hashed;
            let application_hashed;

            let stream_id;
            let application_name;
            let stream_name;

            const stream_payload = document.getElementById("stream_payload");
            if (stream_payload) {
                stream_data_string = stream_payload.attributes["data-stream-data"].value;
                stream_data = JSON.parse(stream_data_string);

                stream_id = stream_data.vm_stream_id;
                application_name = stream_data.application;
                stream_name = stream_data.stream;

                stream_id_hashed = md5(stream_data.vm_stream_id);
                stream_name_hashed = md5(stream_data.stream);
                application_hashed = md5(stream_data.application);
            } else {
                reject({error: "Stream data not available"});
            }

            let found_stream = false;
            let cdn_link;
            for (let i = 0; i < this.jsonEng.length; i++) {
                try {
                    let server_hash = this.jsonEng[i];
                    let jsonReq = this.getJsonURL(server_hash);
                    let jsonDataAxios = await axios.get(jsonReq, {
                        crossDomain: true,
                    });
                    let jsonData = jsonDataAxios.data;

                    if (!jsonData) {
                        // no payload return error
                        continue;
                    }

                    let playlist_url = "";
                    let server_cdn_hashed = "";
                    let server_cdn_id = "";
                    let server_cdn_url = "";
                    let stream_block_list = [];
                    let timestamp = "";
                    let server_name = "";

                    // eu => server CDN
                    // pf => cdn ID
                    // bs => block list :: hashed stream name
                    // hl => stream playerlist with placeholders
                    // sn => engine name hashed :: engine1, engine2, engine3 ...
                    // cd => cdn base 64

                    try {
                        Object.keys(jsonData).forEach((key, value) => {
                            let dataValue = jsonData.hasOwnProperty(key)
                                ? jsonData[key]
                                : null;
                            // server CDN
                            if (key === "eu") {
                                server_cdn_hashed = dataValue;
                            }
                            // cdn ID
                            if (key === "pf") {
                                server_cdn_id = dataValue;
                            }
                            // block list
                            if (key === "bs") {
                                stream_block_list = dataValue;
                            }
                            // timestamp
                            if (key === "timestamp") {
                                timestamp = dataValue;
                            }
                            // stream playlist
                            if (key === "hl") {
                                playlist_url = atob(dataValue);
                            }
                            // engine name :: hashed
                            if (key === "sn") {
                                server_name = dataValue;
                            }
                            // cdn :: base64
                            if (key === "cd") {
                                server_cdn_url = atob(dataValue);
                            }
                        });
                    } catch (error) {
                        console.error(error);
                        continue;
                    }

                    const dataTable = {
                        hashed_app: this.appMD5,
                        app: this.app,
                        serverCDN: server_cdn_hashed,
                        serverCDN_id: server_cdn_id,
                        server_hash: server_hash,
                        block_list: stream_block_list,
                        timestamp: timestamp,
                        stream_name_hashed: stream_name_hashed,
                        application_hashed: application_hashed,
                        server_cdn_url: server_cdn_url,
                        application: application_name,
                        stream_name: stream_name,
                    };

                    // get the app list
                    let appList = jsonData.hasOwnProperty(server_name)
                        ? jsonData[server_name]
                        : [];
                    let foundApp = appList.hasOwnProperty(application_hashed);

                    if (foundApp) {
                        found_stream =
                            appList[application_hashed] != null &&
                            appList[application_hashed].length > 0 &&
                            appList[application_hashed].includes(
                                stream_name_hashed,
                            );
                    }

                    // found the stream running
                    if (found_stream) {
                        // build the url
                        playlist_url = playlist_url.replace(
                            "{CDN_PREFIX}",
                            server_cdn_url,
                        );
                        playlist_url = playlist_url.replace(
                            "{APPLICATION_NAME}",
                            application_name,
                        );
                        playlist_url = playlist_url.replace(
                            "{STREAM_NAME}",
                            stream_name,
                        );
                        cdn_link = playlist_url;
                        break;
                    }
                } catch (e) {
                    console.log(e.message);
                    console.log(JSON.stringify(e));
                    msraStreamStateError += 1;
                }
            }

            // checks if user is offline, or no response from all of the stream state urls
            if (msraStreamStateError >= this.jsonEng.length) {
                reject({error: "no response from all msra files"});
            }

            resolve({running: found_stream, link: cdn_link});
        });
    }

    async getAllCookies() {
        return document.cookie.split(";").map((input) => {
            let splited = {};
            let temp = input.split("=");
            // trim to remove initial spaces if it appears after splitting
            if (temp) {
                if (temp[0]) {
                    splited.name = temp[0].trim();
                }
                if (temp[1]) {
                    splited.value = temp[1].trim();
                }
            }
            return splited;
        });
    }

    async identifyUser(stream_id, application_name, stream_name, stream_data) {
        var enable_viewers_report = Boolean(stream_data?.enable_viewers_report);
        var stream_session = stream_data?.stream_session;

        var uniqueToken = null;
        try {
            uniqueToken = localStorage.getItem(`uuid_stream_${stream_id}`);
            if( !uniqueToken ) {
                uniqueToken = newViewerToken();
                localStorage.setItem(`uuid_stream_${stream_id}`, uniqueToken);
            }
        } catch (e) {
            // storage blocked (private mode, partitioned iframe): keep one id for this page
            this.fallbackViewerToken = this.fallbackViewerToken || newViewerToken();
            uniqueToken = this.fallbackViewerToken;
        }
        
        // const re = new RegExp("^access");,
        let cookieAccessCode;
        let cookiesUserId;

        try {
            let allCookies = await this.getAllCookies();
            if (allCookies.length > 0) {
                cookieAccessCode = allCookies.filter(
                    (cookie) => cookie.name.startsWith('access_') // get access code starts with access_
                );
                cookiesUserId = allCookies.filter(
                    (cookie) => cookie.name === "itrn-jwescax",
                );
            }
        } catch(e) {
            console.error(e);
        }

        const basePayload = {
            v_type: "N",
            v_value: uniqueToken,
            s_sess: stream_session,
            a_name: application_name,
            s_name: stream_name
        };

        if (!enable_viewers_report) {
            return basePayload;
        }

        const user_id = stream_data?.userId || cookiesUserId?.[0]?.value;
        if (user_id) {
            return {
                v_type: "U",
                v_value: user_id,
                s_sess: stream_session,
                a_name: application_name,
                s_name: stream_name
            };
        }

        if (cookieAccessCode?.[0]?.value) {
            return {
                v_type: "A",
                v_value: cookieAccessCode[0].value,
                s_sess: stream_session,
                a_name: application_name,
                s_name: stream_name
            };
        }

        return basePayload;
    }

    getRequest(restApi, successFnc, errorCb) {
        let data = { sid: this.encId };

        this.callFetch(
            this.serverUrl + restApi,
            (resp) => {
                successFnc(resp);
            },
            (error) => {
                errorCb(error);
            },
            data,
            "GET",
        );
    }
}
